import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import EcommerceTemplate from './EcommerceTemplate'
import { lang } from '../../assets/lang'

const instagram_addon = window.xitFlowBuilderData.instagram_addon
var recurring_notification_addon = window.xitFlowBuilderData.recurring_notification_addon
var instagram_recurring_notification_addon = window.xitFlowBuilderData.instagram_recurring_notification_addon

var recurring_notification_display = 0;
if(!instagram_addon && recurring_notification_addon)
  recurring_notification_display = 1;
if(instagram_addon && instagram_recurring_notification_addon)
  recurring_notification_display = 1;

export default class EcommerceComponent extends Rete.Component {
  constructor (config) {
    super(CONST_COMPONENT.ECOMMERCE)

    this.data.component = EcommerceTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !! window.xitFlowBuilderData.is_openai_addon_access
    this.isConditionAddonAvailable = !!window.xitFlowBuilderData.messenger_bot_condition
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder (node) {
    node.lingualName = lingualName.ECOMMERCE
    this.setConnection()

    const ecommerceInput = new Rete.Input(CONST_SOCKET.ECOMMERCE_INPUT, lang.ecommerce_socket_input_reply, this.socket.ecommerceInput, true)
    const ecommerceOutput = new Rete.Output(CONST_SOCKET.ECOMMERCE_OUTPUT, lang.ecommerce_socket_output_next, this.socket.ecommerceOutput, false)
    const ecommerceOutputQuickreply = new Rete.Output(CONST_SOCKET.ECOMMERCE_OUTPUT_QUICKREPLY, lang.ecommerce_socket_output_quick_replies, this.socket.ecommerceOutputQuickreply, true)

    node.addInput(ecommerceInput)
    node.addOutput(ecommerceOutput)

    if (! instagram_addon) {
      node.addOutput(ecommerceOutputQuickreply)
    }

    return node
  }

  // eslint-disable-next-line
  worker (node, inputs, outputs) {
    outputs[CONST_SOCKET.ECOMMERCE_OUTPUT] = node.data
  }

  setConnection() {
    // Ecommerce may be connected to:
    this.socket.ecommerceOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.ecommerceOutput.combineWith(this.socket.openaiInput)
    this.socket.ecommerceOutput.combineWith(this.socket.carouselInput)
    this.socket.ecommerceOutput.combineWith(this.socket.imageInput)

    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.ecommerceOutput.combineWith(this.socket.conditionInput)
    }

    if (!this.isInstagramAddonAvailable) {
      this.socket.ecommerceOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.ecommerceOutput.combineWith(this.socket.videoInput)
      this.socket.ecommerceOutput.combineWith(this.socket.audioInput)
      this.socket.ecommerceOutput.combineWith(this.socket.fileInput)
      // this.socket.ecommerceOutput.combineWith(this.socket.otnInput)
    }
    
    if(recurring_notification_display)
      this.socket.ecommerceOutput.combineWith(this.socket.rcnInput)

    this.socket.ecommerceOutput.combineWith(this.socket.ecommerceInput)
    this.socket.ecommerceOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.ecommerceOutput.combineWith(this.socket.componentListInput)

    if(this.http_api_module)
    {
      this.socket.ecommerceOutput.combineWith(this.socket.httpApiInput)
    }

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.ecommerceOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output (QuickReply): QuickReply
    this.socket.ecommerceOutputQuickreply.combineWith(this.socket.quickReplyInput)    
  }
}